import { apiFetch } from './apiFetch';
import type { Location } from '@deposits/shared';

export async function fetchLocations(): Promise<Location[]> {
  return apiFetch<Location[]>('/locations');
}
